import React, { useEffect, useContext, useState } from 'react';
import { FilePond, registerPlugin } from 'react-filepond';
import { FirebaseContext } from './Firebase';
import { useForm } from 'react-hook-form';
import { navigate, Link } from 'gatsby';
import { Loader, Modal } from '@mantine/core';
// import { connect, useSelector } from 'react-redux';
// import reduxStore from '../state/ReduxStore';
// import { increment, decrement, reset } from '../state/Actions/CounterActions';
import FileUploader from './FileUploader';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

import programs from '../utils/programs.json';
// import { toggleDarkMode } from '../state/app';
import Tabs from './Tabs';
import team1 from '../assets/images/team-1-1.jpg';
import team2 from '../assets/images/team-1-1.jpg';
import courseD1 from '../assets/images/course-d-1.jpg';
import lcImage1 from '../assets/images/lc-1-1.jpg';
import lcImage2 from '../assets/images/lc-1-2.jpg';
import lcImage3 from '../assets/images/lc-1-3.jpg';

// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginFileValidateType
);

const CourseDetails = ({ title }) => {
  const generator = require('generate-password');
  const [loaded, setLoaded] = useState(false);
  const str = '100008286439';
  var parts = str.match(/.{1,4}/g);
  var new_value = parts.join('-'); //returns 123-456-789
  const [pendingDetails, setPendingDetails] = useState({});
  const [loading, setIsLoading] = useState(false);
  const [showBox, setShowBox] = useState(false);
  const [succModal, setSuccModal] = useState(false);
  const [pendingModal, setPendingModal] = useState(false);
  const [showBoxTitle, setShowBoxTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [paymentRRR, setPaymentRRR] = useState('');
  const [transId, setTransId] = useState('');
  const { firebase } = useContext(FirebaseContext);
  const [files, setFiles] = useState([]);
  const [filesList, setFilesList] = useState([]);
  const course = programs.find((el) => el.name === title) || '';
  let docURLs = [];
  // let paymentRRR = null;
  // let transId = '';
  const date = new Date();
  const month = date.getMonth() + 1;
  const [checker, setChecker] = useState(false);

  // const counterData = useSelector((state) => state.counterData);
  const { register, handleSubmit, errors, watch } = useForm();

  const uploadDocsPromise = (docFile, userId) => {
    const path = `registrations/${userId}/docs/`;
    return new Promise((resolve, reject) => {
      if (!docFile) return reject('No document to upload');
      firebase
        .storeFiles({ path: path + docFile.file.name, docFile: docFile.file })
        .then((urls) => {
          docURLs.push(urls);
          resolve(urls);
        });
    });
  };

  const onSubmit = (formData) => {
    setChecker(true);
    setIsLoading(true);
    firebase
      .preRegisteredUser({ email: formData.email })
      .then((result) => {
        // console.log('user does exists', result.data.uid);
        if (result.data !== null) {
          firebase.fetchRRR({ id: result.data.uid }).then((data) => {
            setIsLoading(false);

            if (data !== undefined) {
              if (data.data.status === '021' || data.data.status === '025') {
                setPendingDetails({ ...data.data });
                setPendingModal(true);
              } else if (data.data.status === '00') {
                navigate('/profile');
              } else {
                setIsLoading(false);
                setModalMessage(
                  `An error occurred while making payment ${data.data.message}`
                );
                setShowBoxTitle('Payment Error');
                setShowBox(true);
              }
            }
          });
        }
      })
      .catch((error) => {
        firebase
          .generateRRR(formData)
          .then((data) => {
            const parsed = data.data.parseJsonP;
            if (parsed.statuscode === '025' || parsed.statuscode === '021' ) {
              const password = generator.generate({
                length: 8,
                numbers: true,
                uppercase: true,
              });
              // const password = 'Password1';
              firebase
                .registerAccount({ email: formData.email, password })
                .then((credent) => {
                  Promise.all(
                    filesList.map((item) =>
                      uploadDocsPromise(item, credent.user.uid)
                    )
                  ).then(() => {
                    const dbData = {
                      rrr: parsed.RRR,
                      userId: credent.user.uid,
                      documents: docURLs,
                      status: 'Not Completed',
                      course: title,
                      name: formData.name,
                      phone: formData.phone,
                    };

                    const callData = {
                      email: formData.email,
                      password,
                      name: formData.name,
                      RRR: parsed.RRR,
                    };
                    firebase
                      .storeRegistration({ dbData, callData })
                      .then(() => {
                        setIsLoading(false);
                        setPaymentRRR(parsed.RRR);
                        setTransId(data.data.orderId);
                        setSuccModal(true);
                      })
                      .catch((error) => {
                        console.log('store registration error', error);
                        setIsLoading(false);
                      });
                  });
                })
                .catch((error) => {
                  console.log('error', error);
                  // setIsLoading(false);
                  // setModalMessage(
                  //   'Email has already been registered, kindly complete payment using the RRR code'
                  // );
                  // setShowBoxTitle('Error while registering account');
                  // setShowBox(true);
                  // console.log('create errore', error);
                });
            } else {
              setIsLoading(false);
              setModalMessage(
                `An error occurred while generating payment, ${parsed.statusMessage}`
              );
              setShowBoxTitle('Payment Error');
              setShowBox(true);
              // console.log(parsed.status);
            }
          })
          .catch((error) => {
            setIsLoading(false);
            setModalMessage('An error occurred, please try again later');
            setShowBoxTitle('Error');
            setShowBox(true);
            // console.log('error in log', error);
          });
      });
  };

  const continuePayment = () => {
    window.open(
      `https://luthschoolpayment.web.app/?code=${
        paymentRRR || pendingDetails.RRR
      }`,
      '_self'
    );
  };
  return (
    <section className='course-details'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-8'>
            <div className='course-details__content'>
              <div className='course-details__top'>
                <div className='course-details__top-left'>
                  <h2 className='course-details__title'>{course.name}</h2>
                </div>
              </div>
              <Tabs>
                <div label='Overview'>
                  <p className='course-details__tab-text'>
                    {course.profile || 'NO PROFILE'}
                  </p>
                </div>
                <div label='Requirements'>
                  <p className='course-details__tab-text'>
                    To be eligible for the course, you must possess the
                    following qualifications:
                  </p>
                  <ul className='list-unstyled course-details__overview-list'>
                    {course &&
                      course.requirements.map((element, ind) => (
                        <li key={ind}>
                          <p style={{ marginBottom: 15 }}>
                            {ind + 1}. {element.name}{' '}
                            {element.sub &&
                              element.sub.map((inner, innInd) => (
                                <p
                                  style={{ paddingLeft: 15, marginBottom: -12 }}
                                  key={innInd}
                                >
                                  {inner.name}
                                </p>
                              ))}
                          </p>
                        </li>
                      ))}
                  </ul>
                </div>
                <div label='Apply'>
                  {/* <p className='course-details__tab-text'>
                    Application forms currently unavailable. Not on SALE. 
                    <br />You may send a mail to{' '}
                      <a href='mailto:info@luth.gov.ng'>
                        info@luth.gov.ng
                      </a> for more information.{' '}
                  </p> */}
                  {
                    // course.name !== 'Health Information Management (HND)' &&
                    // course.name !== 'Health Information Management (ND)' &&
                    // course.name !== 'School of Community Health' &&
                    // course.name !== 'Community Health Officers Program' &&
                    // course.name !== 'Biomedical Engineering (ND)' &&
                    // course.name !== 'Anaesthetic Technicians' &&
                    // course.name !== 'Medical And Psychiatric Social Work' &&
                    // course.name !== 'General Nursing' &&
                    // course.name !== 'Accident & Emergency Program' &&
                    // course.name !== 'Accident & Emergency Program' &&
                    // course.name !== 'Perioperative Program' &&
                    // course.name !== 'Ophthalmic Program' &&
                    course.name !== 'Paediatric Programs' ? (
                      // course.name !== 'Biomedical Engineering (HND)'
                      // course.name !== 'Biomedical Engineering (HND) 2'
                      <p className='course-details__tab-text'>
                        {' '}
                        Application forms currently unavailable. Not on SALE.
                        <br />
                        You may send a mail to{' '}
                        <a href='mailto:info@luth.gov.ng'>
                          info@luth.gov.ng
                        </a>{' '}
                        for more information.{' '}
                      </p>
                    ) : (
                      <React.Fragment>
                        <p className='course-details__tab-text'>
                          To apply for the program, fill the details below with
                          your correct details. <br /> <br />
                          When done, click the <strong>Submit</strong> button
                          and the system will create a login account for you. If
                          successful, you will get a confirmation page with the
                          information that the details of the account have be
                          sent to your email. <br />
                          <br />
                          You can either proceed to make a safe and secure
                          payment through <strong>Remita</strong> by clicking
                          the <strong>Make Payment</strong> button, selecting
                          your preferred payment option and supplying requisite
                          information/ Or you may close the confirmation page
                          and go to your email to retrieve the details and
                          return to login and following the steps outlined in
                          the email to make your payment.
                          <br />
                          <br />
                          If your payment is successful, you payment status in
                          your login page will be updated to PAID. You will then
                          be able to upload any document due as per program
                          requirements.
                          <br />
                          <br />
                          <strong>
                            REQUIREMENTS for Admission into Post Basic Nursing
                            courses;
                          </strong>
                          <br />
                          <br />
                          <strong>Eligibility:</strong> Registered Nurse
                          <br />
                          {/* <strong>
                            School of Health Information Cut-off (ND):
                          </strong>{' '}
                          150 and above Federal
                          <br /> */}
                          <strong>Experience:</strong> At Least One Year
                          <br />
                          <br />
                          <strong>Date of Examination/Interview</strong>
                          <br />
                          <strong>Date:</strong> Saturday 11th January, 2025
                          <br />
                          <strong>Time:</strong> 8:00am
                          <br />
                          <strong>Venue:</strong>Human Resourses Auditorium,
                          LUTH
                          <br />
                          <br />
                          <strong>Note:</strong> Please come with the
                          Original\Photocopy of your credentials and the printed
                          Bio-Data Form.
                          <br />
                          <br />
                          For more information on other schools kindly contact
                          {/* <Link to='mailto:schoolsadmin@luth.gov.ng'>
                            schoolsadmin@luth.gov.ng
                          </Link> */}
                          <br />
                          <a href='mailto:schadmin@luthschools.edu.ng'>
                            email: schadmin@luthschools.edu.ng
                          </a>{' '}
                          <br />
                          Phone Number : 08023156096
                        </p>
                        <section
                          className='contact-one'
                          style={{ paddingTop: 50 }}
                        >
                          <div className='container'>
                            <h2 className='contact-one__title text-center'>
                              Account Creation
                            </h2>
                            <form
                              onSubmit={handleSubmit(onSubmit)}
                              className='contact-one__form contact-form-validated'
                            >
                              <div className='row low-gutters'>
                                <div className='col-lg-6'>
                                  <input
                                    type='text'
                                    name='name'
                                    placeholder='Your Name'
                                    ref={register({ required: true })}
                                  />
                                  {errors.name && (
                                    <span className='errorText'>
                                      <i className='fas fa-exclamation-triangle'></i>{' '}
                                      This field is required
                                    </span>
                                  )}
                                </div>
                                <div className='col-lg-6'>
                                  <input
                                    type='text'
                                    placeholder='Phone Number'
                                    name='phone'
                                    ref={register({ required: true })}
                                  />
                                  {errors.phone && (
                                    <span className='errorText'>
                                      <i className='fas fa-exclamation-triangle'></i>{' '}
                                      This field is required
                                    </span>
                                  )}
                                </div>
                                <div className='col-lg-6'>
                                  <input
                                    type='email'
                                    placeholder='Email Address'
                                    name='email'
                                    ref={register({ required: true })}
                                  />
                                  {errors.email && (
                                    <span className='errorText'>
                                      <i className='fas fa-exclamation-triangle'></i>{' '}
                                      This field is required
                                    </span>
                                  )}
                                </div>
                                <div className='col-lg-6'>
                                  <input
                                    type='email'
                                    placeholder='Confirm Email Address'
                                    name='confirmEmail'
                                    ref={register({
                                      required: true,
                                      validate: (value) =>
                                        value == watch('email') ||
                                        'Emails must match',
                                    })}
                                  />
                                  {errors.confirmEmail &&
                                    errors.confirmEmail.type === 'required' && (
                                      <span className='errorText'>
                                        <i className='fas fa-exclamation-triangle'></i>{' '}
                                        This field is required
                                      </span>
                                    )}
                                  {errors.confirmEmail &&
                                    errors.confirmEmail.type === 'validate' && (
                                      <span className='errorText'>
                                        <i className='fas fa-exclamation-triangle'></i>{' '}
                                        Emails don't match
                                      </span>
                                    )}
                                </div>
                                <div className='col-lg-12'>
                                  <div className='text-center'>
                                    {loading ? (
                                      <Loader
                                        size='xl'
                                        color='orange'
                                        variant='dots'
                                      />
                                    ) : (
                                      <button
                                        type='submit'
                                        className='contact-one__btn thm-btn'
                                      >
                                        Submit
                                      </button>
                                    )}
                                  </div>
                                </div>
                                <Modal
                                  onClose={() => setSuccModal(false)}
                                  size='lg'
                                  opened={succModal}
                                >
                                  <div className='block-title text-left'>
                                    <h2
                                      className='block-title__title'
                                      style={{ textAlign: 'center' }}
                                    >
                                      Login Details Created
                                    </h2>
                                  </div>
                                  <p
                                    className='about-two__text'
                                    style={{ textAlign: 'center' }}
                                  >
                                    A username and password have been created
                                    for you to login to this website and track
                                    your application and payment. The details,
                                    along with the payment due, have been sent
                                    to the email you provided.
                                    <br />
                                    Find below the amount due:
                                    <br />
                                    <strong>Application fee: </strong>20,000.00
                                    <br />
                                    <strong>Transaction charges: </strong>212.06
                                    <br />
                                    <strong>Total: </strong>20,212.06
                                    <br />
                                    <strong>
                                      Remita Retrieval Reference (RRR) code
                                    </strong>{' '}
                                    code:{' '}
                                    <strong>
                                      {paymentRRR &&
                                        paymentRRR.match(/.{1,4}/g).join('-')}
                                    </strong>
                                    <br />
                                    You can close this prompt and check your
                                    email for details and instructions on
                                    payment, or you can proceed to make payment
                                    now by clicking the button below
                                    <br />
                                    <br />
                                    <button
                                      onClick={continuePayment}
                                      className='contact-one__btn thm-btn'
                                    >
                                      Continue To Payment
                                    </button>
                                  </p>
                                </Modal>
                                <Modal
                                  onClose={() => setShowBox(false)}
                                  opened={showBox}
                                  title={showBoxTitle}
                                >
                                  {modalMessage}
                                </Modal>
                                <Modal
                                  size='lg'
                                  onClose={() => setPendingModal(false)}
                                  opened={pendingModal}
                                >
                                  <div className='block-title text-left'>
                                    <h2
                                      className='block-title__title'
                                      style={{ textAlign: 'center' }}
                                    >
                                      Pending
                                    </h2>
                                  </div>
                                  <p
                                    className='about-two__text'
                                    style={{ textAlign: 'center' }}
                                  >
                                    Your payment is still pending, kindly
                                    complete payment with these details to
                                    complete your registration.
                                    <br />
                                    Remita Retrieval Reference:{' '}
                                    <strong>
                                      {pendingDetails.RRR &&
                                        pendingDetails.RRR.match(
                                          /.{1,4}/g
                                        ).join('-')}
                                    </strong>
                                    <br />
                                    <strong>Application fee: </strong>20,000.00
                                    <br />
                                    <strong>Transaction charges: </strong>212.06
                                    <br />
                                    <strong>Total: </strong>20,212.06
                                    <br />
                                    <br />
                                    <button
                                      onClick={continuePayment}
                                      className='contact-one__btn thm-btn'
                                    >
                                      Continue To Payment
                                    </button>
                                  </p>
                                </Modal>
                                <Modal
                                  onClose={() => setShowBox(false)}
                                  opened={showBox}
                                  title={showBoxTitle}
                                >
                                  {modalMessage}
                                </Modal>
                              </div>
                            </form>
                            <div className='result text-center'></div>
                          </div>
                        </section>
                      </React.Fragment>
                    )
                  }

                  {/*                   
                  <React.Fragment>
                    <p className='course-details__tab-text'>
                      To apply for the program, fill the details below with your
                      correct details. <br /> <br />
                      When done, click the <strong>Submit</strong> button and
                      the system will create a login account for you. If
                      successful, you will get a confirmation page with the
                      information that the details of the account have be sent
                      to your email. <br />
                      <br />
                      You can either proceed to make a safe and secure payment
                      through <strong>Remita</strong> by clicking the{' '}
                      <strong>Make Payment</strong> button, selecting your
                      preferred payment option and supplying requisite
                      information/ Or you may close the confirmation page and go
                      to your email to retrieve the details and return to login
                      and following the steps outlined in the email to make your
                      payment.
                      <br />
                      <br />
                      If your payment is successful, you payment status in your
                      login page will be updated to PAID. You will then be able
                      to upload any document due as per program requirements.
                      <br />
                      <br />
                      You may send a mail to{' '}
                      <a href='mailto:info@luth.gov.ng'>
                        info@luth.gov.ng
                      </a>{' '}
                      should you experience any issues or need further
                      clarifications.
                    </p>
                    <section className='contact-one' style={{ paddingTop: 50 }}>
                      <div className='container'>
                        <h2 className='contact-one__title text-center'>
                          Account Creation
                        </h2>
                        <form
                          onSubmit={handleSubmit(onSubmit)}
                          className='contact-one__form contact-form-validated'
                        >
                          <div className='row low-gutters'>
                            <div className='col-lg-6'>
                              <input
                                type='text'
                                name='name'
                                placeholder='Your Name'
                                ref={register({ required: true })}
                              />
                              {errors.name && (
                                <span className='errorText'>
                                  <i className='fas fa-exclamation-triangle'></i>{' '}
                                  This field is required
                                </span>
                              )}
                            </div>
                            <div className='col-lg-6'>
                              <input
                                type='text'
                                placeholder='Phone Number'
                                name='phone'
                                ref={register({ required: true })}
                              />
                              {errors.phone && (
                                <span className='errorText'>
                                  <i className='fas fa-exclamation-triangle'></i>{' '}
                                  This field is required
                                </span>
                              )}
                            </div>
                            <div className='col-lg-6'>
                              <input
                                type='email'
                                placeholder='Email Address'
                                name='email'
                                ref={register({ required: true })}
                              />
                              {errors.email && (
                                <span className='errorText'>
                                  <i className='fas fa-exclamation-triangle'></i>{' '}
                                  This field is required
                                </span>
                              )}
                            </div>
                            <div className='col-lg-6'>
                              <input
                                type='email'
                                placeholder='Confirm Email Address'
                                name='confirmEmail'
                                ref={register({
                                  required: true,
                                  validate: (value) =>
                                    value == watch('email') ||
                                    'Emails must match',
                                })}
                              />
                              {errors.confirmEmail &&
                                errors.confirmEmail.type === 'required' && (
                                  <span className='errorText'>
                                    <i className='fas fa-exclamation-triangle'></i>{' '}
                                    This field is required
                                  </span>
                                )}
                              {errors.confirmEmail &&
                                errors.confirmEmail.type === 'validate' && (
                                  <span className='errorText'>
                                    <i className='fas fa-exclamation-triangle'></i>{' '}
                                    Emails don't match
                                  </span>
                                )}
                            </div>
                            <div className='col-lg-12'>
                              <div className='text-center'>
                                {loading ? (
                                  <Loader
                                    size='xl'
                                    color='orange'
                                    variant='dots'
                                  />
                                ) : (
                                  <button
                                    type='submit'
                                    className='contact-one__btn thm-btn'
                                  >
                                    Submit
                                  </button>
                                )}
                              </div>
                            </div>
                            <Modal
                              onClose={() => setSuccModal(false)}
                              size='lg'
                              opened={succModal}
                            >
                              <div className='block-title text-left'>
                                <h2
                                  className='block-title__title'
                                  style={{ textAlign: 'center' }}
                                >
                                  Login Details Created
                                </h2>
                              </div>
                              <p
                                className='about-two__text'
                                style={{ textAlign: 'center' }}
                              >
                                A username and password have been created for
                                you to login to this website and track your
                                application and payment. The details, along with
                                the payment due, have been sent to the email you
                                provided.
                                <br />
                                Find below the amount due:
                                <br />
                                <strong>Application fee: </strong>10,000.00
                                <br />
                                <strong>Transaction charges: </strong>212.06
                                <br />
                                <strong>Total: </strong>10,212.06
                                <br />
                                <strong>
                                  Remita Retrieval Reference (RRR) code
                                </strong>{' '}
                                code:{' '}
                                <strong>
                                  {paymentRRR &&
                                    paymentRRR.match(/.{1,4}/g).join('-')}
                                </strong>
                                <br />
                                You can close this prompt and check your email
                                for details and instructions on payment, or you
                                can proceed to make payment now by clicking the
                                button below
                                <br />
                                <br />
                                <button
                                  onClick={continuePayment}
                                  className='contact-one__btn thm-btn'
                                >
                                  Continue To Payment
                                </button>
                              </p>
                            </Modal>
                            <Modal
                              onClose={() => setShowBox(false)}
                              opened={showBox}
                              title={showBoxTitle}
                            >
                              {modalMessage}
                            </Modal>
                            <Modal
                              size='lg'
                              onClose={() => setPendingModal(false)}
                              opened={pendingModal}
                            >
                              <div className='block-title text-left'>
                                <h2
                                  className='block-title__title'
                                  style={{ textAlign: 'center' }}
                                >
                                  Pending
                                </h2>
                              </div>
                              <p
                                className='about-two__text'
                                style={{ textAlign: 'center' }}
                              >
                                Your payment is still pending, kindly complete
                                payment with these details to complete your
                                registration.
                                <br />
                                Remita Retrieval Reference:{' '}
                                <strong>
                                  {pendingDetails.RRR &&
                                    pendingDetails.RRR.match(/.{1,4}/g).join(
                                      '-'
                                    )}
                                </strong>
                                <br />
                                <strong>Application fee: </strong>10,000.00
                                <br />
                                <strong>Transaction charges: </strong>212.06
                                <br />
                                <strong>Total: </strong>10,212.06
                                <br />
                                <br />
                                <button
                                  onClick={continuePayment}
                                  className='contact-one__btn thm-btn'
                                >
                                  Continue To Payment
                                </button>
                              </p>
                            </Modal>
                            <Modal
                              onClose={() => setShowBox(false)}
                              opened={showBox}
                              title={showBoxTitle}
                            >
                              {modalMessage}
                            </Modal>
                          </div>
                        </form>
                        <div className='result text-center'></div>
                      </div>
                    </section>
                  </React.Fragment> */}
                </div>
              </Tabs>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='course-details__price'>
              <p className='course-details__price-text'>
                Application Fee (excl. charges)
              </p>
              <p className='course-details__price-amount'>₦20,000</p>
            </div>

            <div className='course-details__meta'>
              <a href='#none' className='course-details__meta-link'>
                <span className='course-details__meta-icon'>
                  <i className='far fa-clock'></i>
                </span>
                Duration: <span>{course.duration}</span>
              </a>
            </div>
            {course.similar && (
              <div className='course-details__list'>
                <h2 className='course-details__list-title'>Similar</h2>
                {course.similar.map((element, idx) => (
                  <div className='course-details__list-item' key={idx}>
                    <div className='course-details__list-content'>
                      <h3>
                        <Link to={element.link}>{element.name}</Link>
                      </h3>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

// export default connect(
//   (state) => ({
//     isDarkMode: state.app.isDarkMode,
//   }),
//   null
// )(CourseDetails);

export default CourseDetails;
